import { FREE_SIGNUP_CREDITS } from '../../config/credits'

export const DESIGNERS_SEO = {
  title: 'KartinAi для дизайнеров — оптовые условия на AI-генерацию',
  description:
    'Платформа для дизайнеров и студий: изображения, иллюстрации, инфографика и правки. Оптовые кредиты, обучение команды и персональная поддержка.',
  path: '/designers',
}

export const DESIGNERS_NAV = [
  { href: '#benefits', label: 'Для кого' },
  { href: '#tools', label: 'Инструменты' },
  { href: '#how', label: 'Как подключиться' },
  { href: '#contact', label: 'Заявка' },
] as const

export const DESIGNERS_HERO = {
  badge: 'Для дизайнеров и студий',
  titleAccent: 'AI-студия',
  titleRest: 'для дизайнеров',
  subtitle:
    'Генерируйте визуал для клиентов быстрее: мокапы, иллюстрации, инфографика и правки — с оптовыми условиями для фриланса и студий.',
  trialBadge: `${FREE_SIGNUP_CREDITS} кредитов и 14 дней премиума — сразу после регистрации`,
  primaryCta: 'Оставить заявку',
  secondaryCta: 'Попробовать бесплатно',
  previewSub: 'Клиентский проект',
  previewPrompt: 'Создай концепт упаковки и три варианта для презентации клиенту...',
}

export const DESIGNERS_AUDIENCE = [
  {
    title: 'Фриланс-дизайнер',
    desc: 'Больше проектов без найма подрядчиков — один сервис для картинок, правок и презентаций.',
  },
  {
    title: 'Студия 2–10 человек',
    desc: 'Общий баланс, обучение команды и единые условия для всех дизайнеров.',
  },
  {
    title: 'In-house у бренда',
    desc: 'Быстрые итерации мокапов, social и упаковки без очереди в production.',
  },
] as const

export const DESIGNERS_WHOLESALE = [
  {
    title: 'Оптовые кредиты',
    desc: 'Скидка на объём и пакетные условия — обсуждаем под ваш поток задач.',
  },
  {
    title: 'Персональный менеджер',
    desc: 'Помощь с тарифом, моделями и типовыми сценариями под ваших клиентов.',
  },
  {
    title: 'Обучение команды',
    desc: 'Короткий онбординг: промпты, I2I, карточки и инфографика под ваш стиль.',
  },
  {
    title: 'Приоритетная поддержка',
    desc: 'Быстрее ответы по техническим вопросам и спорным генерациям.',
  },
] as const

export const DESIGNERS_FEATURES = [
  {
    title: 'Изображения',
    desc: 'Концепты, moodboard, product shot и вариации для клиента.',
  },
  {
    title: 'Правки I2I',
    desc: 'Доработка макета по референсу без перерисовки с нуля.',
  },
  {
    title: 'Иллюстрация',
    desc: 'Вектор и стилизация под брендбук.',
  },
  {
    title: 'Инфографика',
    desc: 'Слои, текст, экспорт для презентаций и social.',
  },
] as const

export const DESIGNERS_EXAMPLES = [
  { title: 'Концепт упаковки', desc: 'Product shot и вариации под бриф клиента.' },
  { title: 'Редактирование по референсу', desc: 'I2I — правки без перерисовки с нуля.' },
  { title: 'Иллюстрация для бренда', desc: 'Стилизация под фирменный визуальный язык.' },
  { title: 'Инфографика', desc: 'Слои и текст для презентаций и social.' },
  { title: 'Мокап для презентации', desc: 'Быстрые итерации для согласования с заказчиком.' },
  { title: 'Визуал для кампании', desc: 'Креативы под ключевые сообщения бренда.' },
] as const

export const DESIGNERS_STEPS = [
  {
    step: '1',
    title: 'Оставьте заявку',
    desc: 'Расскажите, студия вы или фриланс, и какие задачи закрываете чаще всего.',
  },
  {
    step: '2',
    title: 'Короткий созвон',
    desc: 'Подберём модели, объём и формат обучения под ваш процесс.',
  },
  {
    step: '3',
    title: 'Доступ с условиями',
    desc: 'Подключаем оптовый тариф и сопровождаем первые генерации.',
  },
] as const

export const DESIGNERS_CONTACT = {
  title: 'Оптовые условия — индивидуально',
  bullets: [
    'Пакеты кредитов и скидка на объём',
    'Обучение 1-on-1 или для команды',
    'Помощь с промптами под ваших клиентов',
    'Без обязательств до созвона',
  ],
  telegramPrefill: 'Здравствуйте! Хочу обсудить оптовые условия KartinAi для дизайнеров.',
  formSuccess: 'Заявка отправлена. Ответим в течение 1 рабочего дня.',
  mailSubject: 'Заявка: оптовые условия KartinAi для дизайнеров',
}

export const DESIGNERS_FINAL_CTA = {
  title: 'Не ждите созвона — попробуйте сервис бесплатно',
  desc: 'Зарегистрируйтесь и протестируйте генерацию на своих задачах. Оптовые условия подключим после заявки.',
  button: 'Попробовать бесплатно',
}

export const DESIGNERS_LOGOS_STRIP =
  'Дизайнеры используют KartinAi для брендов, агентств и студий'

export const DESIGNERS_LEAD_TYPES = [
  { value: 'freelance', label: 'Фриланс' },
  { value: 'studio', label: 'Студия' },
  { value: 'inhouse', label: 'In-house у бренда' },
] as const
